export const sidebarBackground = 'radial-gradient(55.13% 55.13% at 15.68% 15.88%, #1B183A 0%, #080717 100%)';
